export type ImportationRequestMessages = {
  removeImportationSuccess: string;
  removeImportationError: string;
  markImportationAsReadSuccess: string;
  markImportationAsReadError: string;
  markAllImportationsAsReadSuccess: string;
  markAllImportationsAsReadError: string;
};

export const IMPORTATION_REQUEST_MESSAGES: ImportationRequestMessages = {
  removeImportationSuccess: "Importação removida com sucesso!",
  removeImportationError: "Erro ao remover a importação!",
  markImportationAsReadSuccess: "Importação marcada como lida com sucesso!",
  markImportationAsReadError: "Erro ao marcar a importação como lida!",
  markAllImportationsAsReadSuccess: "Todas as importações foram marcadas como lidas!",
  markAllImportationsAsReadError: "Erro ao marcar todas as importações como lidas!",
};

export default IMPORTATION_REQUEST_MESSAGES;
